import { ScoreboardPage } from '@contexts/Scoreboard/components/ScoreboardPage'

export const Home = () => {
  return <ScoreboardPage />
}
